export interface TranslationDictionary {
  [culture: string]: string;
}

export function getTranslationDictionarySchema(additionalDescription?: string) {
  return {
    type: 'object',
    description:
      'Translation dictionary. Each property key is a language/culture id, for example en, de, pl, no, sv, es; each value is the translated text string. ' +
      (additionalDescription ?? ''),
    additionalProperties: { type: 'string' },
  };
}
